import { common } from '@src/api/actions';
import { getSafe } from '@src/tools/util';
import model from './model';
export const fetchCompanyList = () => model.list.cache(() => common.getAllCompanyList().then((res) => getSafe(res, 'data.company_list', [])));
